import { Action } from "./action";
import { ActionDescriptor } from "./action_descriptor";
import { ActionSet } from "./action_set";
import { InlineActionObserver } from "./inline_action_observer";
import { Scope } from "./scope";
var Context = /** @class */ (function () {
    function Context(contextSet, element) {
        this.contextSet = contextSet;
        this.scope = new Scope(this.configuration, this.identifier, element);
        this.actions = new ActionSet(this);
        this.inlineActionObserver = new InlineActionObserver(this, this);
        try {
            this.controller = new contextSet.controllerConstructor(this);
            this.controller.initialize();
        }
        catch (error) {
            this.reportError(error, "initializing controller \"" + this.identifier + "\"");
        }
    }
    Context.prototype.connect = function () {
        this.actions.start();
        this.inlineActionObserver.start();
        try {
            this.controller.connect();
        }
        catch (error) {
            this.reportError(error, "connecting controller \"" + this.identifier + "\"");
        }
    };
    Context.prototype.disconnect = function () {
        try {
            this.controller.disconnect();
        }
        catch (error) {
            this.reportError(error, "disconnecting controller \"" + this.identifier + "\"");
        }
        this.inlineActionObserver.stop();
        this.actions.stop();
    };
    Object.defineProperty(Context.prototype, "application", {
        get: function () {
            return this.contextSet.application;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "identifier", {
        get: function () {
            return this.contextSet.identifier;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "configuration", {
        get: function () {
            return this.application.configuration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "element", {
        get: function () {
            return this.scope.element;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "parentElement", {
        get: function () {
            return this.element.parentElement;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.addAction = function (actionOrDescriptorString, eventTarget) {
        var action;
        if (actionOrDescriptorString instanceof Action) {
            action = actionOrDescriptorString;
        }
        else if (typeof actionOrDescriptorString == "string") {
            var descriptorString = actionOrDescriptorString;
            if (!isEventTarget(eventTarget)) {
                eventTarget = this.element;
            }
            var descriptor = ActionDescriptor.forElementWithInlineDescriptorString(eventTarget, descriptorString);
            action = new Action(this, descriptor, eventTarget);
        }
        if (action) {
            this.actions.add(action);
        }
    };
    Context.prototype.removeAction = function (action) {
        this.actions.delete(action);
    };
    // Inline action observer delegate
    Context.prototype.inlineActionConnected = function (action) {
        this.addAction(action);
    };
    Context.prototype.inlineActionDisconnected = function (action) {
        this.removeAction(action);
    };
    // Logging
    Context.prototype.reportError = function (error, message) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var argsFormat = args.map(function (arg) { return "%o"; }).join("\n");
        var format = "Error %s\n\n%o\n\n" + argsFormat + "\n%o\n%o";
        return console.error.apply(console, [format, message, error].concat(args, [this.controller, this.element]));
    };
    return Context;
}());
export { Context };
function isEventTarget(object) {
    if (!object) {
        return false;
    }
    else if (typeof EventTarget != "undefined") {
        return object instanceof EventTarget;
    }
    else {
        return typeof object.addEventListener == "function";
    }
}
//# sourceMappingURL=data:application/json;base64,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